<template>
    <div class="high-seas-management-wrap">
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left"></div>
            <div class="page-filter_wrap_right">
                <el-button type="primary" @click="handleClickAdd">新建公海</el-button>
            </div>
        </div>
        <div class="page-content" v-loading="loading">
            <CustomVxeTable ref="tableRef" :tableData="tableData" :reduceHeight="reduceHeight" :showPagination="false">
                <vxe-column field="seas_name" title="公海名称" fixed="left" min-width="230" show-overflow>
                    <template #default="{ row }">
                        <span>{{ row.seas_name }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="admins" title="公海管理员" min-width="250" show-overflow>
                    <template #default="{ row }">
                        <template v-if="row.admins && row.admins.length">
                            <span>{{ row.admins.map((item) => item.relate_name).join("、") }}</span>
                        </template>
                        <span v-else>--</span>
                    </template>
                </vxe-column>
                <vxe-column field="members" title="公海成员" min-width="280" show-overflow>
                    <template #default="{ row }">
                        <template v-if="row.members && row.members.length">
                            <span>{{ row.members.map((item) => item.relate_name).join("、") }}</span>
                        </template>
                        <span v-else>--</span>
                    </template>
                </vxe-column>
                <vxe-column
                    field="daily_limit"
                    title="每日申领上限"
                    header-align="right"
                    align="right"
                    min-width="200"
                    show-overflow
                >
                    <template #default="{ row }">
                        <span v-if="row.daily_limit || row.daily_limit === 0">{{ row.daily_limit }}</span>
                        <span v-else>不限</span>
                    </template>
                </vxe-column>
                <vxe-column
                    field="customer_count"
                    title="公海客户数量"
                    header-align="right"
                    align="right"
                    min-width="200"
                    show-overflow
                >
                    <template #default="{ row }">
                        <span>{{ row.customer_count }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="name" title="操作" fixed="right" width="86">
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <el-tooltip effect="dark" content="编辑" placement="top"
                                ><i class="iconfont icon-bianji" @click="handleClickEdit(row)"></i
                            ></el-tooltip>
                            <el-tooltip effect="dark" content="删除" placement="top"
                                ><i class="iconfont icon-shanchu1" @click="handleClickDel(row)"></i
                            ></el-tooltip>
                        </div>
                    </template>
                </vxe-column>
                <template #empty>
                    <span>暂无数据</span>
                </template>
            </CustomVxeTable>
        </div>
        <HighSeasOperator
            ref="HighSeasOperator"
            :operatorDialogVisible.sync="operatorDialogVisible"
            :editId="editId"
            @operatorSuccessCallback="getTableData"
            v-if="operatorDialogVisible"
        />
        <HighSeasDelete
            ref="HighSeasDelete"
            :deleteDialogVisible.sync="deleteDialogVisible"
            :deleteId="deleteId"
            @handleDelCallback="getTableData"
            v-if="deleteDialogVisible"
        />
    </div>
</template>
<script>
import { GetHighSeasManagementList, HighSeasManagementDel } from "@/api";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import HighSeasOperator from "./component/high_seas_operator.vue";
import HighSeasDelete from "./component/high_seas_delete.vue";
export default {
    name: "HighSeasManagement",
    components: { CustomVxeTable, HighSeasOperator, HighSeasDelete },
    data() {
        return {
            reduceHeight: 170,
            loading: false,
            tableData: [],
            editId: 0,
            operatorDialogVisible: false,
            deleteId: "",
            deleteDialogVisible: false,
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.loading = true;
            GetHighSeasManagementList({isSet:true})
                .then((res) => {
                    if (res.code == 200) {
                        this.tableData = res.data;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleClickAdd() {
            this.editId = 0;
            this.operatorDialogVisible = true;
        },
        handleClickEdit(row) {
            this.editId = row.id;
            this.operatorDialogVisible = true;
        },
        handleClickDel(row) {
            if (row.customer_count) {
                // 有公海客户
                this.deleteId = row.id;
                this.deleteDialogVisible = true;
            } else {
                // 没有公海客户，直接删除
                HighSeasManagementDel(row.id, {}).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.message || "删除成功");
                        this.getTableData();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },
    },
};
</script>
<style lang="scss">
.high-seas-management-wrap {
    padding: 16px;
}
</style>
